import React, { useEffect } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import style from "./style";
import classNames from "classnames";
import { IconSuccess } from "../../../../Icons";
import _ from "lodash";


const useStyles = makeStyles(() => createStyles(style()));

type props = {
  onGoogleResponse: any;
  appid: any;
  scope: any;
  AuthGroup: any
};

export const GoogleAuth = (props: props): JSX.Element => {
  const classes = useStyles();


  const {onGoogleResponse, appid, scope, AuthGroup } = props;
  const visibllity = (!_.isEmpty(AuthGroup.value) && !_.isNull(AuthGroup.value)) ? "visible" : "hidden";

   useEffect(() => {
    const channel = new BroadcastChannel("google-auth-channel");
    channel.onmessage = (event) => {
      const QueryParams = new URLSearchParams(event.data.code);
      const AuthCode: any = QueryParams.get("code");
      onGoogleResponse({ code: AuthCode });
    };
    return () => channel.close();
  }, []);

  const openNewTab = (): void => {
    const state = encodeURIComponent(`${window.origin}/google/callback`);
    const width = 599;
    const height = 599;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    const callBack = `${process.env.REACT_APP_SOCIAL_CALLBACK}/googlecallback`;
    const features = `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`;
    const googleOAuthURL = `https://accounts.google.com/o/oauth2/auth?client_id=${appid}&response_type=code&scope=${scope}&redirect_uri=${callBack}&state=${state}&access_type=offline&prompt=consent`;
    window.open(googleOAuthURL, "childwindow", features);
  }; 


  return (
    <div className={classes.googleContainer}>
      <div>
        <button type="button"
          className={classNames(classes.button, "MuiButtonBase-root", classes.buttonNew)}
          disabled={!_.isEmpty(AuthGroup.value) && !_.isNull(AuthGroup.value)}
          onClick={openNewTab} 
        >
          <div className={classes.buttonInner}>
            <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
              <g fill="#000">
                <path d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z" fill="#EA4335">
                </path>
                <path d="M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z" fill="#4285F4"></path>
                <path d="M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z" fill="#FBBC05"></path>
                <path d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z" fill="#34A853"></path>
                <path fill="none" d="M0 0h18v18H0z"></path>
              </g>
            </svg>
          </div>
          <span className={classes.buttonLabel}>Sign in with Google</span>
        </button>


      </div>
      <div className={classes.successIconDiv} style={{ visibility: visibllity }}>
        <IconSuccess />
      </div>
    </div>

  );
};
